var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my-base-info"}},[_c('div',{staticClass:"home-head"},[_c('head-common')],1),_vm._v(" "),_c('base-info',{staticClass:"content"},[_c('h2',[_vm._v("我的基本信息")])]),_vm._v(" "),_c('div',{staticClass:"home-footer"},[_c('footer-common')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377ebf79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/MyBaseInfo.vue
// module id = null
// module chunks = 